"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AffidabilitEStoriaDal1978() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257309" id="affidabilità-e-storia-dal-1978" className="dark bg-background py-20 lg:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-1/2 w-px h-full bg-border/10 hidden lg:block pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imageRef} className="lg:col-span-7 relative">
            <div className={`transition-all duration-1000 ease-out transform ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="relative aspect-[4/5] md:aspect-[16/10] lg:aspect-[4/5] overflow-hidden rounded-md shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/centro_chimica_industrial_heritage.png" alt="Centro Chimica S.r.l. Prato Heritage" className="w-full h-full object-cover grayscale contrast-150 brightness-75" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/centro_chimica_industrial_heritage.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/centro_chimica_industrial_heritage.png-wvc-sizes" loading="lazy" />
                {}
                <div className="absolute inset-0 bg-gradient-to-tr from-background/60 via-transparent to-transparent mix-blend-multiply" />
                <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-background/40 to-transparent" />
              </div>
            </div>
          </div>

          {}
          <div ref={textRef} className="lg:col-span-5 flex flex-col items-start">
            <div className={`transition-all duration-1000 delay-200 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <Badge variant="outline" className="mb-8 border-primary/30 text-primary tracking-widest uppercase text-xs px-3 py-1 rounded-md">
                La Nostra Storia
              </Badge>
              
              <h2 className="sr-only font-default">Affidabilità e Storia dal 1978</h2>
              
              {}
              <p className="text-2xl md:text-[32px] leading-relaxed md:leading-[1.6] font-default font-light text-foreground tracking-tight">
                Dal <span className="text-primary">1978</span>, Centro Chimica S.r.l. è il punto di riferimento nel distretto tessile di <span className="text-primary">Prato</span> per forniture industriali <span className="text-primary">B2B</span> d'eccellenza, garantendo precisione tecnica e continuità operativa.
              </p>

              <div className="mt-12 pt-10 border-t border-border/20 w-full">
                {}
                <p className="font-serif italic text-xl md:text-2xl text-muted-foreground leading-relaxed">
                  "La nostra solidità nasce dalla profonda conoscenza delle materie prime e dal legame indissolubile con il territorio toscano."
                </p>
                
                <div className="mt-6 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
                  <div>
                    <p className="font-default font-semibold text-sm tracking-widest uppercase text-foreground">
                      Ufficio Direzionale
                    </p>
                    <p className="text-xs text-muted-foreground mt-1 uppercase tracking-wider font-mono">
                      Centro Chimica S.r.l.
                    </p>
                  </div>
                  
                  <Button variant="default" size="lg" asChild className="rounded-md shadow-md bg-primary text-primary-foreground hover:bg-primary/90">
                    
                  </Button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}